import React, { useState } from 'react';

import { ADD_PAGE_GHOST_HOVER_STYLE, ADD_PAGE_GHOST_PLUS_STYLE, ADD_PAGE_GHOST_STYLE } from './blueprint-view-styles';

export type BlueprintAddPageGhostProps = {
	onAdd: () => void;
};

/**
 * The next-sheet affordance: an empty, dashed page sitting in the stack below the last real
 * sheet, with a plus in the middle. Deliberately carries NO `data-blueprint-page` attribute —
 * that is what the PDF/PPTX export enumerates, so the ghost can never become a blank page in
 * an exported document.
 */
export const BlueprintAddPageGhost = (props: BlueprintAddPageGhostProps): React.ReactElement => {
	const { onAdd } = props;

	const [isHovered, setIsHovered] = useState(false);

	return (
		<button
			type='button'
			onClick={onAdd}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
			style={isHovered ? { ...ADD_PAGE_GHOST_STYLE, ...ADD_PAGE_GHOST_HOVER_STYLE } : ADD_PAGE_GHOST_STYLE}
			title='Add a blank CUSTOM PANEL sheet'
			aria-label='Add a blank custom panel sheet'
			data-blueprint-sheet-slot='add-page'
		>
			<span style={ADD_PAGE_GHOST_PLUS_STYLE}>+</span>
		</button>
	);
};
